import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { adaptWorker, isPremiumWorker, ini } from "../lib/helpers";
import { Stars } from "./ui/Stars";
import { Btn } from "./ui/Btn";
import { Av } from "./ui/Av";
import { TopNav } from "./ui/TopNav";
import { EmptyBox } from "./WorkFlow";
import { VerifiedBadge, PremiumBadge } from "./WorkerProfile";

export const BuscarAyudante = ({setScreen, user}) => {
  const [ayudantes, setAyudantes] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [oficio, setOficio]       = useState("Ayudante de Obra");

  useEffect(() => {
    setLoading(true);
    supabase
      .from("trabajadores")
      .select("*")
      .or(`oficio.eq.Ayudante de Obra,oficio.eq.${oficio}`)
      // FIX F1-6: incluir registros donde visible_directorio es null (campo nuevo/vacío).
      .or("visible_directorio.eq.true,visible_directorio.is.null")
      .order("calificacion", { ascending: false })
      .limit(20)
      .then(({ data, error }) => {
        if (!error) setAyudantes((data || []).map(adaptWorker));
        setLoading(false);
      });
  }, [oficio]);

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="obra-activa" backLabel="Mi Obra" title="Buscar Ayudante"/>
      <div style={{maxWidth:640,margin:"0 auto",padding:"20px"}}>
        <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentD})`,borderRadius:20,padding:20,color:"#fff",marginBottom:16,boxShadow:`0 6px 20px ${C.accent}40`}}>
          <div style={{fontSize:32,marginBottom:6}}>🦺</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:900,marginBottom:4}}>Ayudantes verificados</div>
          <div style={{fontSize:13,opacity:.88}}>Todos tienen INE validado · Reputación real en Ficio</div>
        </div>

        <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
          {["Ayudante de Obra","Albañil","Pintor","Jardinero"].map(o=>(
            <button key={o} onClick={()=>setOficio(o)}
              style={{background:oficio===o?C.accent:C.surface,border:`1.5px solid ${oficio===o?C.accent:C.border}`,
                borderRadius:20,padding:"7px 14px",color:oficio===o?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer"}}>
              {o}
            </button>
          ))}
        </div>

        {loading ? (
          <div style={{textAlign:"center",padding:"40px",color:C.muted}}>Buscando ayudantes...</div>
        ) : ayudantes.length === 0 ? (
          <EmptyBox icon="🦺" title="Sin ayudantes disponibles" desc="No hay ayudantes registrados en esta categoría aún."/>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {ayudantes.map(a => (
              <div key={a.id} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:18,padding:18,boxShadow:"0 2px 8px rgba(0,0,0,.04)"}}>
                <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
                  <Av letters={a.avatar || ini(a.name)} color={C.accent} size={52} dot={a.available}/>
                  <div style={{flex:1}}>
                    <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:800,color:C.text,marginBottom:2}}>{a.name}</div>
                    <div style={{color:C.accent,fontSize:12,fontWeight:600,marginBottom:6}}>{a.trade} · {a.zone}</div>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                      <Stars rating={a.rating}/><span style={{color:C.muted,fontSize:11}}>{a.reviews} reseñas · {a.exp} años exp.</span>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      {a.verified && <VerifiedBadge small/>}
                      {isPremiumWorker(a) && <PremiumBadge small/>}
                    </div>
                  </div>
                </div>
                <div style={{marginTop:14,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  {/* FIX F1-6/F3-17: teléfono solo visible para usuarios autenticados */}
                  {user ? (
                    <a href={`https://wa.me/52${String(a.phone||"").replace(/\D/g,"")}?text=${encodeURIComponent("Hola, vi tu perfil en FICIO como ayudante y me interesa contratarte.")}`}
                      target="_blank" rel="noreferrer"
                      style={{display:"block",background:"#25D366",color:"#fff",textDecoration:"none",borderRadius:12,padding:"10px",textAlign:"center",fontWeight:800,fontSize:13}}>
                      💬 WhatsApp
                    </a>
                  ) : (
                    <Btn small full color={C.green} onClick={()=>setScreen("cliente-login")}>💬 Contactar</Btn>
                  )}
                  <Btn small full color={C.accent} onClick={()=>window.ficioToast?.("Toca el nombre del maestro para ver su perfil completo.", "info")}>Ver perfil</Btn>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
